import React from "react";
import { FiHome, FiChevronRight } from "react-icons/fi";

const BreadCrumb = ({ title, trail = [] }) => {
  return (
    <div className="mb-4">
      <div className="flex items-center text-sm text-gray-500 gap-1">
        <FiHome className="w-4 h-4" />

        {trail.map((item, index) => (
          <React.Fragment key={index}>
            <FiChevronRight className="w-3 h-3" />
            <span
              className={`${
                index === trail.length - 1
                  ? "text-gray-900 font-medium"
                  : "cursor-pointer hover:text-gray-700"
              }`}
            >
              {item}
            </span>
          </React.Fragment>
        ))}
      </div>

      {/* Page heading */}
      <h1 className="mt-3 text-2xl md:text-3xl font-semibold text-gray-900">
        {title}
      </h1>
    </div>
  );
};

export default BreadCrumb;
